import { render } from "./NotesTable.vue?vue&type=template&id=2803fe60&scoped=true"
import script from "./NotesTable.vue?vue&type=script&lang=js"
export * from "./NotesTable.vue?vue&type=script&lang=js"

import "./NotesTable.vue?vue&type=style&index=0&id=2803fe60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2803fe60"]])

export default __exports__